import * as React from 'react';
import { compose } from 'recompose';
import ProfileBox from './ProfileBox';
import { Head, Left, LogoLink, Logo, Right } from '../../components/UI/TopBarUI';
import Images from '../../constants/Images';
import { withTheme } from 'styled-components';

type Props = {
  theme: any;
};

const TopBar: React.SFC<Props> = ({ theme }) => {
  const logo = theme.mode === 'light' ? Images.splashDark : Images.splashLight;
  return (
    <Head>
      <Left>
        <LogoLink to="/">
          <Logo src={logo} alt="" />
        </LogoLink>
      </Left>
      <Right>
        <ProfileBox />
      </Right>
    </Head>
  );
};

export default compose(withTheme)(TopBar);



// WEBPACK FOOTER //
// ./src/containers/Site/TopBar.tsx